module.exports = __webpack_public_path__ + "img/image_body-point_03_02.95b79c04.svg";